import React from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';
import PropTypes from 'prop-types';

import {
  Heading,
  Text,
  WithTooltip
} from 'components/common/Elements/Elements';
import CustomReaseonTooltip from './parts/CustomReaseonTooltip/CustomReaseonTooltip';

import { colorsNew } from 'components/common/charts/helpers/config.js';

import classes from './Reason.module.scss';

const Reason = ({ dataChart }) => {
  const { t } = useTranslation(['activity']);
  return (
    <section className={classes.wrap}>
      <Heading>{t('activity:filters.CANCELLATION_REASON')}</Heading>

      <ul className={classes.chartWrap}>
        {dataChart.length > 0 ? (
          dataChart.map((item, index) => (
            <WithTooltip
              className={classes.tooltip}
              placement={'top-start'}
              text={
                <CustomReaseonTooltip
                  dataTooltip={item}
                  color={colorsNew[index]}
                />
              }
              key={index}
            >
              <li
                style={{
                  width: `calc(${item.percent}%`,
                  backgroundColor: colorsNew[index]
                }}
                className={classes.itemChart}
              >
                <Text
                  type="p"
                  className={cn(
                    classes.valuePercent,
                    index % 2 === 0
                      ? classes.valuePercent_pair
                      : classes.valuePercent_isNotPair
                  )}
                >
                  <Text className={classes.visually_hidden}>
                    {`Name ${item.name}, Count ${item.count}, Percent `}
                  </Text>
                  {`${item.percent}%`}
                </Text>
              </li>
            </WithTooltip>
          ))
        ) : (
          <li className={cn(classes.itemChart, classes.preloaderDefault)} />
        )}
      </ul>
    </section>
  );
};

Reason.propTypes = {
  dataChart: PropTypes.array
};

export default Reason;
